const prefixRegexp = new RegExp(`^/(develop/|empathy/|discovery/)?`);

function currentFlavorPrefix(): string | undefined {
  const { pathname } = window.location;

  const match = pathname.match(prefixRegexp);
  if (match) return match[0];
}

/**
 * Prepends `path` with the specified `flavor`, if it does not already
 * exist. For example, with `path`: `/features/123` and `flavor`:
 * `develop`, will return `/develop/features/123`.
 *
 * If `flavor` is unspecified, it will be set automatically by the
 * current page URL.
 */
export function flavoredPath(path: string, flavor: string | null = null) {
  if (!path.startsWith('/')) return path;
  if (path.startsWith('/api')) return path;

  let prefix: string | null | undefined = null;

  if (flavor === null) {
    prefix = currentFlavorPrefix();
  } else if (flavor === '' || flavor === 'roadmap') {
    prefix = '/';
  } else {
    prefix = `/${flavor}/`;
  }

  const unflavoredPath = path.replace(prefixRegexp, '');
  return `${prefix}${unflavoredPath}`;
}
